<template>
  <div>
    <!-- Main Table Tabs -->
    <div class="tabs">
      <button
        class="tab"
        :class="{ 'tab-active': mainActiveTab === 'images' }"
        @click="mainActiveTab = 'images'"
        type="button"
      >
        Images
      </button>
      <button
        class="tab"
        :class="{ 'tab-active': mainActiveTab === 'factoryDetails' }"
        @click="mainActiveTab = 'factoryDetails'"
        type="button"
      >
        Factory Details
      </button>
      <button
        class="tab"
        :class="{ 'tab-active': mainActiveTab === 'productionDetails' }"
        @click="mainActiveTab = 'productionDetails'"
        type="button"
      >
        Production Details
      </button>
    </div>

    <div class="table-container">
      <!-- Images Table -->
      <b-table
        v-show="mainActiveTab === 'images'"
        striped
        hover
        :items="items"
        :fields="imagesFields"
        :per-page="10"
        :current-page="currentPage"
        id="factory-images-table"
        responsive
      >
      <template v-slot:cell(imageUrls)="data">
  <div v-if="data.item.imageUrls && data.item.imageUrls.length">
    <a
      v-for="(url, index) in data.item.imageUrls"
      :key="`url-${index}`"
      :href="url"
      target="_blank"
      class="image-url-link"
    >
      {{ truncateUrl(url) }}<span v-if="index < data.item.imageUrls.length - 1">, </span>
    </a>
  </div>
  <span v-else>-</span>
   </template>
        <template v-slot:cell(actions)="data">
          <button
            class="btn btn-info btn-sm dropdown-toggle"
            type="button"
            id="dropdownMenuButton"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            Action
          </button>
          <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
            <b-button
              v-b-modal.modal-prevent-closing
              @click="openEditModal(data.item._id)"
              class="dropdown-item"
            >
              <i class="fa fa-edit"></i>
              Edit
            </b-button>
            <button
              class="dropdown-item"
              @click="showDeletePrompt(data.item._id)"
            >
              <i class="fa fa-trash text-danger"></i>
              Delete
            </button>
          </div>
        </template>
      </b-table>

      <!-- Factory Details Table -->
      <b-table
        v-show="mainActiveTab === 'factoryDetails'"
        striped
        hover
        :items="items"
        :fields="factoryDetailsFields"
        :per-page="10"
        :current-page="currentPage"
        id="factory-details-table"
        responsive
      >
        <template v-slot:cell(rawMaterials)="data">
          {{
            data.item.type === 'Biochar Facility' && data.item.biocharMaterials
              ? data.item.biocharMaterials.join(', ')
              : data.item.rawMaterials || '-'
          }}
        </template>
        <template v-slot:cell(actions)="data">
          <button
            class="btn btn-info btn-sm dropdown-toggle"
            type="button"
            id="dropdownMenuButton"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            Action
          </button>
          <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
            <b-button
              v-b-modal.modal-prevent-closing
              @click="openEditModal(data.item._id)"
              class="dropdown-item"
            >
              <i class="fa fa-edit"></i>
              Edit
            </b-button>
            <button
              class="dropdown-item"
              @click="showDeletePrompt(data.item._id)"
            >
              <i class="fa fa-trash text-danger"></i>
              Delete
            </button>
          </div>
        </template>
      </b-table>

      <!-- Production Details Table -->
      <b-table
        v-show="mainActiveTab === 'productionDetails'"
        striped
        hover
        :items="items"
        :fields="productionDetailsFields"
        :per-page="10"
        :current-page="currentPage"
        id="factory-production-table"
        responsive
      >
        <template v-slot:cell(inputRate)="data">
          {{
            data.item.type === 'Biochar Facility' && data.item.inputRate
              ? data.item.inputRate
              : '-'
          }}
        </template>
        <template v-slot:cell(outputRate)="data">
          {{
            data.item.type === 'Biochar Facility' && data.item.outputRate
              ? data.item.outputRate
              : '-'
          }}
        </template>
        <template v-slot:cell(productionCapacity)="data">
          {{ data.item.productionCapacity ? data.item.productionCapacity : '-' }}
        </template>
        <template v-slot:cell(processedVolume)="data">
          {{ data.item.processedVolume ? data.item.processedVolume : '-' }}
        </template>
        <template v-slot:cell(inventoryLevels)="data">
          {{ data.item.inventoryLevels ? data.item.inventoryLevels : '-' }}
        </template>
        <template v-slot:cell(actions)="data">
          <button
            class="btn btn-info btn-sm dropdown-toggle"
            type="button"
            id="dropdownMenuButton"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            Action
          </button>
          <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
            <b-button
              v-b-modal.modal-prevent-closing
              @click="openEditModal(data.item._id)"
              class="dropdown-item"
            >
              <i class="fa fa-edit"></i>
              Edit
            </b-button>
            <button
              class="dropdown-item"
              @click="showDeletePrompt(data.item._id)"
            >
              <i class="fa fa-trash text-danger"></i>
              Delete
            </button>
          </div>
        </template>
      </b-table>
    </div>

    <b-modal
      id="modal-prevent-closing"
      ref="modal"
      title="Edit Factory"
      hide-footer
      @hide="resetEditFactory"
    >
      <div class="tabs">
        <button
          class="tab"
          :class="{ 'tab-active': modalActiveTab === 'images' }"
          @click="modalActiveTab = 'images'"
          type="button"
        >
          Images
        </button>
        <button
          class="tab"
          :class="{ 'tab-active': modalActiveTab === 'factoryDetails' }"
          @click="modalActiveTab = 'factoryDetails'"
          type="button"
        >
          Factory Details
        </button>
        <button
          class="tab"
          :class="{ 'tab-active': modalActiveTab === 'productionDetails' }"
          @click="modalActiveTab = 'productionDetails'"
          type="button"
        >
          Production Details
        </button>
      </div>

      <form ref="form" @submit.stop.prevent="updateFactory">
        <!-- Images Tab -->
        <div v-show="modalActiveTab === 'images'" class="tab-content">
          <b-form-group label="Image URLs (Optional)" label-for="image-urls">
            <div class="url-inputs-container">
              <div
                v-for="(url, index) in editFactory.imageUrls"
                :key="`edit-url-${index}`"
                class="url-input-row"
              >
                <b-form-input
                  :id="`image-url-${index}`"
                  type="text"
                  v-model="editFactory.imageUrls[index]"
                  placeholder="Enter Google Drive Image URL"
                  class="url-input"
                ></b-form-input>
                <b-button
                  v-if="index > 0"
                  variant="danger"
                  size="sm"
                  class="cancel-btn"
                  @click="removeEditUrl(index)"
                >
                  ×
                </b-button>
              </div>
              <b-button
                variant="primary"
                size="sm"
                class="action-btn add-url-btn"
                @click="addEditUrl"
              >
                Add More Image URL
              </b-button>
            </div>
          </b-form-group>
          <div class="btn-container">
            <b-button
              type="submit"
              variant="primary"
              :disabled="isImagesInvalid"
              @click="modalActiveTab = 'images'"
            >
              Update Images
            </b-button>
          </div>
        </div>

        <!-- Factory Details Tab -->
        <div v-show="modalActiveTab === 'factoryDetails'" class="tab-content">
          <b-form-group label="Name" label-for="name-input">
            <b-form-input
              id="name-input"
              v-model="editFactory.name"
              required
            ></b-form-input>
          </b-form-group>
          <b-form-group label="Latitude" label-for="latitude-input">
            <b-form-input
              id="latitude-input"
              type="number"
              step="any"
              v-model="editFactory.latitude"
              required
            ></b-form-input>
          </b-form-group>
          <b-form-group label="Longitude" label-for="longitude-input">
            <b-form-input
              id="longitude-input"
              type="number"
              step="any"
              v-model="editFactory.longitude"
              required
            ></b-form-input>
          </b-form-group>
          <b-form-group label="Type" label-for="type-input">
            <b-form-select
              id="type-input"
              v-model="editFactory.type"
              :options="typeOptions"
              required
              @change="onTypeChange"
            ></b-form-select>
          </b-form-group>
          <b-form-group label="Status" label-for="status-input">
            <b-form-select
              id="status-input"
              v-model="editFactory.status"
              :options="statusOptions"
              required
            ></b-form-select>
          </b-form-group>
          <b-form-group
            v-if="editFactory.type !== 'Biochar Facility'"
            label="Raw Material"
            label-for="rawMaterials-input"
          >
            <b-form-select
              id="rawMaterials-input"
              v-model="editFactory.rawMaterials"
              :options="materialOptions"
              required
            ></b-form-select>
          </b-form-group>
          <b-form-group
            v-if="editFactory.type === 'Biochar Facility'"
            label="Raw Materials"
            label-for="biocharMaterials-input"
          >
            <b-form-checkbox-group
              id="biocharMaterials-input"
              v-model="editFactory.biocharMaterials"
              :options="biocharMaterialOptions"
              stacked
            ></b-form-checkbox-group>
          </b-form-group>
          <div class="btn-container">
            <b-button
              type="submit"
              variant="primary"
              :disabled="isFactoryDetailsInvalid"
              @click="modalActiveTab = 'factoryDetails'"
            >
              Update Factory Details
            </b-button>
          </div>
        </div>

        <!-- Production Details Tab -->
        <div v-show="modalActiveTab === 'productionDetails'" class="tab-content">
          <b-form-group
            v-if="editFactory.type === 'Biochar Facility'"
            label="Input Rate (tons/day)"
            label-for="input-rate"
          >
            <b-form-input
              id="input-rate"
              type="number"
              v-model="editFactory.inputRate"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            label="Production Capacity (Optional, tons/day)"
            label-for="production-capacity"
          >
            <b-form-input
              id="production-capacity"
              type="number"
              step="any"
              v-model="editFactory.productionCapacity"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            label="Processed Volume (Optional, tons)"
            label-for="processed-volume"
          >
            <b-form-input
              id="processed-volume"
              type="number"
              step="any"
              v-model="editFactory.processedVolume"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            label="Inventory Levels (Optional, tons)"
            label-for="inventory-levels"
          >
            <b-form-input
              id="inventory-levels"
              type="number"
              step="any"
              v-model="editFactory.inventoryLevels"
            ></b-form-input>
          </b-form-group>
          <div class="btn-container">
            <b-button
              type="submit"
              variant="primary"
              :disabled="isProductionDetailsInvalid"
              @click="modalActiveTab = 'productionDetails'"
            >
              Update Production Details
            </b-button>
          </div>
        </div>
      </form>
    </b-modal>

    <b-pagination
      v-model="currentPage"
      :total-rows="rows"
      :per-page="10"
      :aria-controls="getAriaControlsId()"
    ></b-pagination>
    <p class="mt-3">Current Page: {{ currentPage }}</p>
  </div>
</template>

<script>
export default {
  name: "Factory",
  data() {
    return {
      currentPage: 1,
      mainActiveTab: "factoryDetails", // Default tab for main table
      modalActiveTab: "factoryDetails", // Default tab for edit modal
      imagesFields: [
        { key: "name", label: "Name" }, // Added for reference
        { key: "imageUrls", label: "Image URLs" },
        { key: "actions", label: "Action" },
      ],
      factoryDetailsFields: [
        { key: "name", label: "Name" },
        { key: "latitude", label: "Latitude" },
        { key: "longitude", label: "Longitude" },
        { key: "rawMaterials", label: "Raw Materials" },
        { key: "status", label: "Status" },
        { key: "type", label: "Type" },
        { key: "actions", label: "Action" },
      ],
      productionDetailsFields: [
        { key: "name", label: "Name" }, // Added for reference
        { key: "inputRate", label: "Input Rate" },
        { key: "outputRate", label: "Output Rate" },
        { key: "productionCapacity", label: "Production Capacity" },
        { key: "processedVolume", label: "Processed Volume" },
        { key: "inventoryLevels", label: "Inventory Levels" },
        { key: "actions", label: "Action" },
      ],
      materialOptions: [
        { value: null, text: "Please select an option", disabled: true },
        { value: "FFB", text: "FFB" },
        { value: "P1", text: "P1" },
        { value: "P2", text: "P2" },
        { value: "PKO", text: "PKO" },
      ],
      biocharMaterialOptions: [
        { value: "PKS", text: "PKS" },
        { value: "Maize", text: "Maize" },
        { value: "Factory Waste", text: "Factory Waste" },
      ],
      typeOptions: [
        { value: null, text: "Please select an option", disabled: true },
        { value: "Crushing Mill", text: "Crushing Mill" },
        { value: "FFB Mill", text: "FFB Mill" },
        { value: "Deshelling Mill", text: "Deshelling Mill" },
        { value: "Kraken II", text: "Kraken II" },
        { value: "Refinery", text: "Refinery" },
        { value: "Biochar Facility", text: "Biochar Facility" },
      ],
      statusOptions: [
        { value: null, text: "Please select an option", disabled: true },
        { value: "Active", text: "Active" },
        { value: "Inactive", text: "Inactive" },
        { value: "Underconstruction", text: "Underconstruction" },
        { value: "Planned (2025)", text: "Planned (2025)" },
        { value: "Planned (2026)", text: "Planned (2026)" },
      ],
      items: [],
      editFactory: {
        _id: '',
        name: '',
        latitude: null,
        longitude: null,
        rawMaterials: null,
        biocharMaterials: [],
        inputRate: null,
        status: null,
        type: null,
        imageUrls: [""],
        productionCapacity: null,
        processedVolume: null,
        inventoryLevels: null,
      },
      singleFactory: {},
    };
  },
  mounted() {
    this.getFactory();
  },
  computed: {
    rows() {
      return this.items.length;
    },
    isImagesInvalid() {
      return false;
    },
    isFactoryDetailsInvalid() {
      return (
        !this.editFactory.name?.trim() ||
        this.editFactory.latitude == null ||
        this.editFactory.longitude == null ||
        !this.editFactory.type ||
        !this.editFactory.status ||
        (this.editFactory.type !== 'Biochar Facility' && !this.editFactory.rawMaterials) ||
        (this.editFactory.type === 'Biochar Facility' && !this.editFactory.biocharMaterials.length)
      );
    },
    isProductionDetailsInvalid() {
      return (
        this.editFactory.type === 'Biochar Facility' &&
        (this.editFactory.inputRate == null || isNaN(parseFloat(this.editFactory.inputRate)))
      );
    },
  },
  methods: {
    getAriaControlsId() {
      switch (this.mainActiveTab) {
        case "images":
          return "factory-images-table";
        case "factoryDetails":
          return "factory-details-table";
        case "productionDetails":
          return "factory-production-table";
        default:
          return "factory-details-table";
      }
    },
    async getFactory() {
      try {
        const factory = await this.$store.dispatch("markers/fetchFactories");
        this.items = factory;
      } catch (error) {
        this.$toastr.e("Failed to fetch factories");
      }
    },
    async showDeletePrompt(itemId) {
      try {
        const isDeleteConfirmed = await this.$bvModal.msgBoxConfirm(
          "Please confirm that you want to delete this Factory.",
          {
            size: "md",
            buttonSize: "sm",
            okVariant: "danger",
            okTitle: "YES",
            cancelTitle: "NO",
            footerClass: "p-2",
            hideHeaderClose: false,
            centered: true,
          }
        );
        if (!isDeleteConfirmed) return;
        const res = await this.$store.dispatch("markers/deleteMarker", itemId);
        if (res.data) {
          this.$toastr.s("Factory successfully deleted");
          this.items = this.items.filter((factory) => factory._id !== itemId);
        }
      } catch (error) {
        this.$toastr.e("Failed to delete factory");
      }
    },
    async openEditModal(_id) {
      try {
        const factory = await this.$store.dispatch("markers/fetchSingleFactory", _id);
        this.editFactory = {
          _id: factory._id || '',
          name: factory.name || '',
          latitude: factory.latitude != null ? parseFloat(factory.latitude) : null,
          longitude: factory.longitude != null ? parseFloat(factory.longitude) : null,
          rawMaterials: factory.rawMaterials || null,
          biocharMaterials: Array.isArray(factory.biocharMaterials) ? factory.biocharMaterials : [],
          inputRate: factory.inputRate != null ? parseFloat(factory.inputRate) : null,
          status: factory.status || null,
          type: factory.type || null,
          imageUrls: Array.isArray(factory.imageUrls) && factory.imageUrls.length ? factory.imageUrls : [""],
          productionCapacity: factory.productionCapacity != null ? parseFloat(factory.productionCapacity) : null,
          processedVolume: factory.processedVolume != null ? parseFloat(factory.processedVolume) : null,
          inventoryLevels: factory.inventoryLevels != null ? parseFloat(factory.inventoryLevels) : null,
        };
        this.modalActiveTab = "factoryDetails"; 
        this.$refs.modal.show();
      } catch (error) {
        console.error("Error fetching factory details:", error);
        this.$toastr.e("Failed to fetch factory details");
      }
    },
    onTypeChange() {
      if (this.editFactory.type === 'Biochar Facility') {
        this.editFactory.rawMaterials = null;
      } else {
        this.editFactory.biocharMaterials = [];
        this.editFactory.inputRate = null;
      }
    },
    addEditUrl() {
      this.editFactory.imageUrls.push("");
    },
    removeEditUrl(index) {
      this.editFactory.imageUrls.splice(index, 1);
      if (this.editFactory.imageUrls.length === 0) {
        this.editFactory.imageUrls.push("");
      }
    },
    truncateUrl(url) {
      return url.length > 30 ? url.substring(0, 27) + "..." : url;
    },
    async updateFactory() {
      try {
        // Validate based on active tab
        if (this.modalActiveTab === 'factoryDetails' && this.isFactoryDetailsInvalid) {
          this.$toastr.e("Please fill all required fields in Factory Details");
          return;
        }
        if (this.modalActiveTab === 'productionDetails' && this.isProductionDetailsInvalid) {
          this.$toastr.e("Please fill all required fields in Production Details");
          return;
        }

        const payload = {
          id: this.editFactory._id,
          name: this.editFactory.name,
          latitude: parseFloat(this.editFactory.latitude),
          longitude: parseFloat(this.editFactory.longitude),
          status: this.editFactory.status,
          type: this.editFactory.type,
          markerType: 'Factory',
          imageUrls: this.editFactory.imageUrls
            .filter((url) => url.trim() !== "")
            .map((url) => url.trim()),
          productionCapacity: this.editFactory.productionCapacity
            ? parseFloat(this.editFactory.productionCapacity)
            : undefined,
          processedVolume: this.editFactory.processedVolume
            ? parseFloat(this.editFactory.processedVolume)
            : undefined,
          inventoryLevels: this.editFactory.inventoryLevels
            ? parseFloat(this.editFactory.inventoryLevels)
            : undefined,
        };
        if (this.editFactory.type === 'Biochar Facility') {
          payload.biocharMaterials = this.editFactory.biocharMaterials;
          payload.inputRate = this.editFactory.inputRate ? parseFloat(this.editFactory.inputRate) : null;
        } else {
          payload.rawMaterials = this.editFactory.rawMaterials;
        }
        const res = await this.$store.dispatch("markers/updateMarker", payload);
        if (res.status === 200) {
          this.$toastr.s("Factory successfully updated");
          await this.getFactory();
          this.$refs.modal.hide();
        }
      } catch (error) {
        console.error("Error updating factory:", error);
        this.$toastr.e("Failed to update factory");
      }
    },
    resetEditFactory() {
      this.editFactory = {
        _id: '',
        name: '',
        latitude: null,
        longitude: null,
        rawMaterials: null,
        biocharMaterials: [],
        inputRate: null,
        status: null,
        type: null,
        imageUrls: [""],
        productionCapacity: null,
        processedVolume: null,
        inventoryLevels: null,
      };
      this.modalActiveTab = "factoryDetails";
    },
  },
};
</script>

<style scoped>
.dashboard {
  display: flex;
  flex-direction: column;
}
.navbar {
  width: 100%;
  height: 50px;
  display: flex;
  justify-content: space-around;
  align-items: right;
  background-color: #09571d;
  color: #fff;
}
.navbar a {
  color: #fff;
  text-decoration: none;
}
.body {
  display: flex;
  justify-content: center;
}
.sidebar {
  width: 20%;
  background-color: #f5f5f5;
  padding: 20px;
}
.main-content {
  width: 80%;
  padding: 20px;
}

.table-container {
  overflow-x: auto;
  width: 100%;
  margin-top: 1rem;
}

.url-inputs-container {
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
  margin-bottom: 1rem;
  width: 100%;
}

.url-input-row {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.url-input {
  flex: 1;
  height: auto;
  padding: 0.5rem;
  font-size: 0.9rem;
}

.cancel-btn {
  min-width: 32px;
  height: 32px;
  padding: 0;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.2rem;
  line-height: 1;
}

.action-btn {
  margin-top: 0.5rem;
}

.add-url-btn {
  background-color: #28a745;
  border-color: #28a745;
}

.add-url-btn:hover {
  background-color: #218838;
  border-color: #1e7e34;
}

.tabs {
  display: flex;
  margin-bottom: 1rem;
  border-radius: 5px;
  overflow: hidden;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}

.tab {
  flex: 1;
  padding: 0.8rem;
  background: #f5f5f5;
  border: none;
  text-align: center;
  font-size: 0.9rem;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s, color 0.2s;
  border-right: 1px solid #e0e0e0;
}

.tab:last-child {
  border-right: none;
}

.tab-active {
  background-color: #4caf50;
  color: white;
}

.tab-content {
  padding: 1rem;
  background: #fff;
  border-radius: 5px;
}

.btn-container {
  display: flex;
  justify-content: flex-end;
  margin-top: 1rem;
}

/* Pagination styling */
.pagination {
  margin-top: 1.5rem;
  justify-content: center;
}

.image-url-link {
  color: #007bff;
  text-decoration: none;
}

.image-url-link:hover {
  text-decoration: underline;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .tabs {
    flex-direction: column;
  }

  .tab {
    border-right: none;
    border-bottom: 1px solid #e0e0e0;
  }

  .tab:last-child {
    border-bottom: none;
  }

  .url-input-row {
    flex-direction: column;
    align-items: flex-start;
  }

  .cancel-btn {
    margin-left: auto;
  }
}
</style>